import { ITheme, mediaQuery } from '@quicktools/shared-components/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    alert: {
      position: 'absolute',
      top: 24,
      zIndex: 100,
      maxWidth: '664px',
      width: '100%',

      [mediaQuery(breakpoints.tablet)]: {
        top: 65,
      },
    },
  }),
  {
    name: 'alert',
  },
);

export default useStyles;
